export enum PageSources {
  CERTIFICATE_OVERVIEW = 'Certificate Overview Landing',
  CERTIFICATE_COHORT_LANDING = 'Certificate Cohort Landing',
  CERTIFICATE_LESSON = 'Certificate Lesson',
  CERTIFICATE_COMPLETION = 'Certificate Completion',
  CERTIFICATE_CURRICULUM = 'Certificate Curriculum',
  CERTIFICATE_HUB_LANDING = 'Certificate Hub Landing',
  CERTIFICATE_SUBSCRIPTION_LANDING = 'Certificate Subscriptions Landing',
  CERTIFICATE_HUB = 'Certificate Hub',
  CERTIFICATE_HOMEPAGE = 'Certificate Homepage',
  CERTIFICATE_REWARD = 'Certificate Reward',
  CERTIFICATE_CHECKOUT = 'Certificate Checkout',
}

export enum Actions {
  START_PROGRAM = 'Start Program',
  CONTINUE_PROGRAM = 'Continue Program',
  EXPAND = 'Expand',
  COLLAPSE = 'Collapse',
  LESSON = 'Lesson',
  NEXT = 'Next lesson',
  PREVIOUS = 'Previous lesson',
  CHECK_ANSWERS = 'Check answers',
  SUBMIT = 'Submit',
  EDIT_RESPONSE = 'Edit response',
  UNLOCK_CERTIFICATE = 'Unlock My Certificate',
  DOWNLOAD = 'Download',
  ADD_TO_LINKEDIN = 'Add to LinkedIn',
  COPY_URL = 'Copy URL',
}

// Certificate Overview

export const OVERVIEW_ROW_INDEX = {
  hero: 0,
  outcomes: 1,
  units: 2,
}
